<div id="admin-tools" [ngClass]="{'admin-tools-show':show}">
<ul>
    <li (click)="refreshTeams()"> refresh teams </li>
    <li (click)="refreshHorizonsTeams()"> refresh horizons teams </li>
    <li (click)="refresApps()"> refresh apps </li>
    <li (click)="refreshEntities()"> refresh entities </li>
    <li (click)="refreshCountries()"> refreshCountries </li>
    <li (click)="refreshTimeZones()"> refreshTimeZones </li>
</ul>
</div>